// extracted by mini-css-extract-plugin
export default {"warning":"obY9x","appear-from-above":"UnRre","appearFromAbove":"UnRre"};